import { render, staticRenderFns } from "./EventName.vue?vue&type=template&id=1cb01ad5&scoped=true&"
import script from "./EventName.vue?vue&type=script&lang=js&"
export * from "./EventName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb01ad5",
  null
  
)

export default component.exports